import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PanelModel } from '../../models/elements/panelModel.model';

@Injectable({
  providedIn: 'root'
})
export class PanelModelService {

  constructor(private httpClient: HttpClient) {
  }

  getByManufacturer(ManufacturerId: number): Observable<PanelModel[]> {
    return this.httpClient.get<PanelModel[]>(environment.API_URL + '/api/admin/elements/panelmodels/getByManufacturer/' + ManufacturerId).pipe(
      map(data => data));
  }

}
